import React from "react";
import DocumentPrintPdfActions from "./DocumentPrintPdfActions";

export default function LoadingReceiptActions({
  dispatchId,
  label,
  compact = false,
}) {
  const safeLabel = (label || `dispatch-${dispatchId}`).replace(/[/\\?%*:|"<>]/g, "-");

  return (
    <DocumentPrintPdfActions
      printPath={`/outward-dispatches/${dispatchId}/loading-receipt/print`}
      pdfPath={`/outward-dispatches/${dispatchId}/loading-receipt/pdf`}
      pdfFilename={`loading-${safeLabel}.pdf`}
      printLabel={compact ? "Print" : "Print slip"}
      pdfLabel="PDF"
      compact={compact}
      printTitle="Print loading slip"
      pdfTitle="Download loading slip PDF"
      testIdPrefix={`loading-slip-${dispatchId}`}
      stopPropagation={compact}
    />
  );
}
